import { ForgetPasswordResetPage } from "@/pages/forget/password/reset";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/forget/password/reset/")({
	component: RouteComponent,
});

function RouteComponent() {
	return <ForgetPasswordResetPage />;
}
